import { render, staticRenderFns } from "./SubRubros.vue?vue&type=template&id=2aac7751&"
import script from "./SubRubros.vue?vue&type=script&lang=js&"
export * from "./SubRubros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports